/**
 * 根据任务状态数值映射为任务状态枚举。
 *
 * 独立于 ImagesTask 模块，避免仅为状态判断而静态引入 canvas（fabric / whee-infinite-canvas）依赖。
 *
 * @param {number} status 任务状态数值
 * @returns {'success' | 'fail' | 'polling'} 任务状态枚举
 */
export function getTaskStatusEnum(status: number): 'success' | 'fail' | 'polling' {
  if (status === 100) {
    return 'success';
  }
  if (status >= 90 && status < 100) {
    return 'fail';
  }
  if (status > 0 && status < 90) {
    return 'polling';
  }
  return 'fail';
}
